import {MAX_MEDIA_BYTES,MAX_MEDIA_DURATION,mediaLimitLabel} from './resumableUpload.js';
const r2Enabled=typeof window!=='undefined'&&import.meta.env?.VITE_USE_R2_MEDIA!=='false';
import {PROXY_MAX_SOURCE_BYTES,estimateProxyBytes,shouldOfferProxy} from './proxySafety.js';
import {createReviewProxy} from './proxyMedia.js';

export const MAX_BATCH_INTERVIEWS=10;
const allowedTypes={'.mp4':'video/mp4','.webm':'video/webm'};

// Validate before sending even a byte to Supabase or the transcription provider.
export function validateBatchInterview(file,metadata){
 const ext=file?.name?.toLowerCase().match(/\.[^.]+$/)?.[0];
 if(!ext||!allowedTypes[ext]||(file.type&&file.type!==allowedTypes[ext]))
  throw new Error('Use an MP4 or WebM video with an audio track.');
 if(!Number.isFinite(file.size)||file.size<=0||file.size>PROXY_MAX_SOURCE_BYTES)
  throw new Error('Source exceeds the 60 GB browser conversion limit.');
 if(!metadata||!Number.isFinite(metadata.duration)||metadata.duration<=0||
   !Number.isFinite(metadata.width)||metadata.width<=0||
   !Number.isFinite(metadata.height)||metadata.height<=0)
  throw new Error('Could not read the source video duration or dimensions.');
 if(metadata.duration>MAX_MEDIA_DURATION)
  throw new Error('Interview exceeds the four-hour transcription limit.');
 if(file.size>MAX_MEDIA_BYTES)
  throw new Error(`This interview exceeds the current ${mediaLimitLabel(MAX_MEDIA_BYTES)} R2 upload limit. Choose a smaller timecode-matched proxy.`);
 return true;
}

// Source metadata is always from the camera original, never the review proxy.
export async function prepareBatchInterview(file,metadata,timing,onProgress=()=>{}){
 validateBatchInterview(file,metadata);
 let uploadFile=file,proxy=null;
 // New R2 media retains the actual recording; no forced lossy 480p proxy.
 // Editors may still manually import a compact timecode-matched proxy.
 if(!r2Enabled&&shouldOfferProxy(file,metadata,MAX_MEDIA_BYTES)){
  const expected=estimateProxyBytes(metadata.duration);
  if(expected<=MAX_MEDIA_BYTES && (file.size>MAX_MEDIA_BYTES||expected<file.size*.85)){
   onProgress('Converting a 480p review proxy locally');
   try{
    const result=await createReviewProxy(file,{metadata,sourceTiming:timing,maxBytes:MAX_MEDIA_BYTES,
     onProgress:progress=>onProgress('Preparing proxy · '+progress+'%')});
    uploadFile=result.file;proxy=result.proxy;
   }catch(error){
    if(file.size>MAX_MEDIA_BYTES)throw error;
    onProgress('Using the unchanged original');
   }
  }
 }
 if(uploadFile.size>MAX_MEDIA_BYTES)
  throw new Error(`The video exceeds the current ${mediaLimitLabel(MAX_MEDIA_BYTES)} upload limit. Upload a smaller proxy at the original frame rate.`);
 return {uploadFile,proxy};
}
